// 员工花名册
export const employeeRosterRouter = [   
    // 套餐设置
    {
      path: '/employeeRoster/setMealSet',
      name: 'setMealSet',
      component: () => import('../views/employeeRoster/setMealSet')
    },
    // 电子合同使用流水
    {
        path: '/employeeRoster/flowManagement',
        name: 'flowManagement',
        component: () => import('../views/employeeRoster/flowManagement')
    },
  ]